'use client';

import { useTranslations } from 'next-intl';
import { HeroBanner, type HeroBannerPageTitle } from '@/components/frontend/common/hero-banner';
import { SectionWrapper } from '@/components/ui/section-wrapper';
import { IndustrySolutionsGrid } from './industry-solutions-grid';

interface IndustrySolution {
    id: string;
    title: string;
    description: string;
    icon: string;
}

export function IndustrySolutionsPageContent({ initialSolutions, initialPageTitle }: { initialSolutions?: IndustrySolution[]; initialPageTitle?: HeroBannerPageTitle | null } = {}) {
    const t = useTranslations('home.industrySolutions');

    return (
        <div className="min-h-screen bg-white dark:bg-gray-950">
            {/* Hero Banner */}
            <HeroBanner
                page="industry-solutions"
                title={t('title')}
                description={t('subtitle')}
                pill={t('pillLabel')}
                className="border-b border-gray-200 dark:border-gray-900"
                initialPageTitle={initialPageTitle}
            />

            {/* Industry Solutions Section */}
            <SectionWrapper
                variant="default"
                padding="lg"
                className="relative"
            >
                {/* Background accents */}
                <div className="pointer-events-none absolute inset-0 opacity-60">
                    <div className="absolute -left-32 top-10 h-64 w-64 rounded-full bg-primary-500/10 blur-3xl" />
                    <div className="absolute right-0 bottom-0 h-72 w-72 rounded-full bg-blue-500/10 blur-3xl" />
                </div>

                <div className="relative z-10">
                    {/* Industry Cards Grid */}
                    <IndustrySolutionsGrid initialSolutions={initialSolutions} />
                </div>
            </SectionWrapper>
        </div>
    );
}

